import { Buffer } from 'buffer'
import Cookies from 'js-cookie'
import api from './api'
import { COOKIES_DOMAIN } from '@src/constants'

export const decodeToken = (token = ''): { exp: number; user_id: string } => {
  try {
    const dataPart = token.split('.')[1]
    return JSON.parse(Buffer.from(dataPart, 'base64').toString())
  } catch (err) {
    return {
      exp: 0,
      user_id: '',
    }
  }
}

// The literal string 'undefined' means a stale serialization, not a token —
// treat it as absent.
const isRealToken = (value: string | null | undefined): value is string => !!value && value !== 'undefined'

// localStorage is the primary store; the cookie mirrors it for cross-subdomain
// handoff. Each source is validated independently so a stale localStorage
// value can't shadow a valid mirrored cookie.
export const readStoredToken = (): string | null => {
  const local = localStorage.getItem('token')
  if (isRealToken(local)) return local
  const cookie = Cookies.get('token')
  return isRealToken(cookie) ? cookie : null
}

export const setTokens = (token: string, refreshToken: string, domain?: string) => {
  if (token) {
    localStorage.setItem('token', token)
    api.defaults.headers.Authorization = `Token ${token}`
    Cookies.set('token', token, { expires: 7, domain })
  }
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken)
    Cookies.set('refreshToken', refreshToken, { expires: 7, domain })
  }
}

export const clearTokens = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  Cookies.remove('token')
  Cookies.remove('refreshToken')
  Cookies.remove('token', { domain: COOKIES_DOMAIN })
  Cookies.remove('refreshToken', { domain: COOKIES_DOMAIN })
}
